module.exports = "<core-header title=\"{{title}}\"></core-header>\n<router-outlet></router-outlet>"